import { createApp } from 'vue'
import initInlineSvg from '@src/core/plugins/inline-svg'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'

const app = createApp(App)
app.use(store)
app.use(router)

initInlineSvg(app)

app.mount('#app')
